export { SubCollectionSectionDS } from './sub-collection-section-ds'
export type { SubCollectionSectionProps } from './sub-collection-section-ds.types'
